import React from 'react';
import { Tabs } from 'antd';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';

/* extracting Tab pane from Tabs */
const { TabPane } = Tabs;

/* React functional component */
const GodownsTabLayout = () => {
  /* extracting navigate from useNavigate() */
  const navigate = useNavigate();
  /* useLocation destructuring */
  const location = useLocation();

  /* function to get the active tab key */
  const getActiveKey = () => {
    if (location.pathname.includes('create')) {
      return 'createGodown';
    }
    if (location.pathname.includes('edit')) {
      return 'editGodown';
    }
    return 'viewAllGodowns';
  };

  return (
    <div className="tabLayout">
      <Tabs
        defaultActiveKey="viewAllGodowns"
        onTabClick={(key: string) => {
          if (key === 'createGodown') {
            navigate('create');
          } else {
            navigate('');
          }
        }}
        activeKey={getActiveKey()}
        tabBarGutter={50}
        destroyInactiveTabPane
      >
        <TabPane tab=" View All Godowns" key="viewAllGodowns">
          <Outlet />
        </TabPane>
        <TabPane tab="Create New Godown" key="createGodown">
          <Outlet />
        </TabPane>
        <TabPane tab="Edit Godown" key="editGodown" disabled>
          <Outlet />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default GodownsTabLayout;
